import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import TextareaAutosize from "vue-textarea-autosize";
import vueDebounce from "vue-debounce";

import "./assets/css/index.scss";
import "./assets/js/index.js";

import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

// Libraries
import "vue2-datepicker/locale/es";
Vue.use(TextareaAutosize);
//

require("./libraries/dayjs");
require("./libraries/vee-validate");
require("./libraries/axios");
require("./libraries/global-components");
require("./libraries/global-functions");
require("./libraries/sweetalert2");

Vue.use(vueDebounce);

// filters
import filters from "./modules/shared/filters";

Object.keys(filters).forEach((filter) => {
  Vue.filter(filter, filters[filter]);
});

// load user from localStorage
store.dispatch("auth/load");

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
